function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 25,
  cy: 25,
  r: 25,
  fill: "#00DCFA"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M30.2591 10C24.8054 10 20.1755 14.1946 19.5918 19.5918C14.1946 20.1755 10 24.8073 10 30.2591C10.002 33.1071 11.1343 35.8379 13.1482 37.8518C15.1621 39.8657 17.8929 40.998 20.7409 41C26.1946 41 30.8427 36.8054 31.4082 31.4082C36.8054 30.8245 41 26.1927 41 20.7409C40.998 17.8929 39.8657 15.1621 37.8518 13.1482C35.8379 11.1343 33.1071 10.002 30.2591 10V10ZM38.4875 21.9446C38.2182 23.7058 37.3932 25.3349 36.1327 26.5942C34.8723 27.8534 33.2424 28.6769 31.4809 28.9444V21.9446H38.4875ZM12.5164 29.0554C12.7814 27.2911 13.6042 25.6579 14.8642 24.3948C16.1242 23.1316 17.7554 22.3049 19.5191 22.0355V29.0401H12.5164V29.0554ZM28.9645 31.4809C28.6714 33.4525 27.6797 35.2531 26.1702 36.5548C24.6606 37.8565 22.7337 38.5726 20.7404 38.5726C18.7472 38.5726 16.8203 37.8565 15.3107 36.5548C13.8012 35.2531 12.8095 33.4525 12.5164 31.4809H28.9645ZM29.0554 21.9446V29.0401H21.9446V21.9446H29.0554ZM38.4836 19.5191H22.0355C22.3286 17.5475 23.3203 15.7469 24.8298 14.4452C26.3394 13.1435 28.2663 12.4274 30.2596 12.4274C32.2528 12.4274 34.1797 13.1435 35.6893 14.4452C37.1988 15.7469 38.1905 17.5475 38.4836 19.5191Z",
  fill: "white"
});

var SvgSourceGemini = function SvgSourceGemini(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSourceGemini, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/source_gemini.009a3e1e.svg";
export { ForwardRef as ReactComponent };